import React, { useRef } from 'react';

export const fileSize = (size: number) => size >= 1024 * 1024 ? `${(size / 1024 / 1024).toFixed(1)} МБ` : `${Math.max(1, Math.round(size / 1024))} КБ`;
const extensions = ['jpg', 'jpeg', 'png', 'webp', 'pdf', 'txt', 'log', 'csv'];
export function addTicketFiles(files: File[], selected: File[]): File[] {
  const combined = [...files];
  for (const file of selected) {
    if (!extensions.includes(file.name.split('.').pop()?.toLowerCase() ?? '') || /(?:^|\.)(?:php\d*|phtml|phar|html?|svg|js|exe|bat|cmd|ps1|sh|dll|com|scr)(?:\.|$)/i.test(file.name)) throw new Error('Этот тип файла не поддерживается.');
    if (file.size > 10 * 1024 * 1024) throw new Error('Размер одного файла — не больше 10 МБ.');
    if (!combined.some(old => old.name === file.name && old.size === file.size && old.lastModified === file.lastModified)) combined.push(file);
  }
  if (combined.length > 5) throw new Error('Можно прикрепить до 5 файлов к сообщению.');
  return combined;
}
export function pasteTicketImages(event: React.ClipboardEvent, files: File[], onChange: (files: File[]) => void, onError: (error: string) => void, disabled: boolean) {
  if (disabled) return;
  const images = Array.from(event.clipboardData.items ?? []).filter(item => item.kind === 'file' && item.type.startsWith('image/')).map(item => item.getAsFile()).filter((file): file is File => file !== null);
  if (!images.length) return;
  event.preventDefault();
  try {
    const selected = images.map((file, index) => {
      const extension = ({ 'image/png': 'png', 'image/jpeg': 'jpg', 'image/webp': 'webp' } as Record<string, string>)[file.type];
      if (!extension) throw new Error('Для скриншотов поддерживаются PNG, JPG и WEBP.');
      return new File([file], `Скриншот-${Date.now()}-${index + 1}.${extension}`, { type: file.type });
    });
    onChange(addTicketFiles(files, selected)); onError('');
  } catch (e) { onError((e as Error).message); }
}

const SelectedImage: React.FC<{ file: File }> = ({ file }) => {
  const [url, setUrl] = React.useState('');
  React.useEffect(() => {
    if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type) || typeof URL.createObjectURL !== 'function') return;
    const value = URL.createObjectURL(file); setUrl(value);
    return () => URL.revokeObjectURL(value);
  }, [file]);
  return url ? <img className="ticket-uploads__thumbnail" src={url} alt="Выбранное изображение" /> : null;
};
const TicketFiles: React.FC<{ files: File[]; onChange: (files: File[]) => void; onError: (error: string) => void; disabled: boolean }> = ({ files, onChange, onError, disabled }) => {
  const input = useRef<HTMLInputElement>(null);
  return <div className="ticket-uploads">
    <input ref={input} type="file" hidden multiple accept={extensions.map(ext => `.${ext}`).join(',')} aria-label="Выбрать вложения" disabled={disabled} onChange={event => {
      const selected = Array.from(event.target.files ?? []); event.target.value = '';
      try { onChange(addTicketFiles(files, selected)); onError(''); } catch (e) { onError((e as Error).message); }
    }} />
    <div className="ticket-uploads__toolbar"><button type="button" className="ui-btn ui-btn--outline ui-btn--sm" disabled={disabled} onClick={() => input.current?.click()}><span aria-hidden="true">＋</span> Прикрепить файлы</button><span>До 5 файлов · по 10 МБ</span></div>
    {files.length > 0 && <ul className="ticket-uploads__files">{files.map((file, index) => <li key={`${file.name}-${index}`}><SelectedImage file={file} /><span title={file.name}>{file.name}</span><small>{fileSize(file.size)}</small><button type="button" disabled={disabled} aria-label={`Убрать ${file.name}`} onClick={() => onChange(files.filter((_, i) => i !== index))}>×</button></li>)}</ul>}
  </div>;
};
export default TicketFiles;
